import { CheckTicketContainer, CheckTicketForm } from "src/partials/check";

export const CheckTicketPage = () => {
  return (
    <CheckTicketContainer title="Cek Tiket">
      <CheckTicketForm />
    </CheckTicketContainer>
  );
};
